export const MOVIE_TYPE = 'movie'
export const SHOW_TYPE = 'show'
export const SERIES_TYPE = 'series'
export const VOD_SERVICE_NAME = 'vod-service'
export const EPG_SERVICE_NAME = 'epg-service'
export const MOVIE_EVENT_TYPE = 'movieEvent'
export const RECOMMENDATION_TYPE = 'recommendation'
export const EPISODES_TYPE = 'episode'
export const SEASONS_TYPE = 'season'
export const VOD_TYPE_STREAM_IQ = [
    MOVIE_TYPE,
    SHOW_TYPE,
    EPISODES_TYPE,
    SEASONS_TYPE,
    SERIES_TYPE,
]
export const playbackPlaceholder = {
    drmInfo: {
        drmId: '',
        drmSystem: 0,
        preAuthTokenUri: '',
        licenseProxyUri: '',
        certificateUri: null,
        drmType: null,
    },
    uri: '',
    playbackPositionUpdateInterval: 0,
    productType: '',
    productId: '',
    pcLevel: 0,
    ageVerificationMessage: {
        activationLevel: 0,
        title: '',
        negativeButtonText: '',
        body: '',
        positiveButtonText: '',
    },
    eventDetails: {
        imageUrl: '',
        title: '',
    },
    position: 0,
    nextVideoDetails: {
        title: '',
        productId: '',
        productType: '',
        thumbnailUri: '',
        showBeforeEndMillis: 0,
        autoSwitchToNextMillis: 0,
    },
    skipIntroDetails: {
        skipIntroShowMillis: 0,
        skipIntroHideMillis: 0,
        skipIntroSeekToMillis: 0,
    },
}

const VOD_CONSTANTS_STREAMIQ = {
    EPG_SERVICE_NAME,
    EPISODES_TYPE,
    MOVIE_EVENT_TYPE,
    MOVIE_TYPE,
    RECOMMENDATION_TYPE,
    SEASONS_TYPE,
    SERIES_TYPE,
    SHOW_TYPE,
    VOD_SERVICE_NAME,
    VOD_TYPE_STREAM_IQ,
    playbackPlaceholder,
}

export default VOD_CONSTANTS_STREAMIQ
